export const DOCUMENT_API_TYPE_EMPLOYEE = 'EMPLOYEE' as const;
export const DOCUMENT_API_TYPE_CONTRACT = 'CONTRACT' as const;

export const allDocumentApiTypes = [DOCUMENT_API_TYPE_EMPLOYEE, DOCUMENT_API_TYPE_CONTRACT];

export type DocumentApiType = (typeof allDocumentApiTypes)[number];
